let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("7NpBF")).then(() => parcelRequire('77FPb'));